var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ep-empty-data"},[(_vm.icon)?[_c('img',{staticClass:"ep-empty-data-icon",attrs:{"src":_vm.icon,"alt":_vm.iconDesc}})]:_vm._e(),_c('div',{staticClass:"ep-empty-data-text"},[_vm._v(_vm._s(_vm.text))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }